// extracted by mini-css-extract-plugin
export default {"PanelContent":"verNpvSsC2PHWOljXCOI","Scrollable":"F0cefjskHweizRDtekGU"};